<script setup lang="ts">
import { computed, ref } from 'vue'
import { NButton } from 'naive-ui'

// Preview and print controls for one version. The preview is the server's
// rendered page (the same renderer the public URL uses) in a same-origin
// iframe; print opens it in a new tab with the on-load print call.
const props = defineProps<{ versionId: number; isDraft: boolean }>()

const open = ref(false)

const previewUrl = computed(() => `/api/v1/cv_versions/${props.versionId}/preview`)

function print(): void {
  window.open(`${previewUrl.value}?print=1`, '_blank', 'noopener')
}
</script>

<template>
  <div class="flex flex-col gap-3" data-testid="cv-preview">
    <div class="flex flex-wrap items-center gap-2">
      <NButton size="small" tertiary data-testid="cv-preview-toggle" @click="open = !open">
        {{ open ? 'Hide preview' : 'Preview' }}
      </NButton>
      <NButton size="small" tertiary data-testid="cv-print" @click="print">Print / Save as PDF</NButton>
      <span v-if="isDraft" class="text-xs text-white/40">Preview and print use the last saved draft.</span>
    </div>
    <iframe
      v-if="open"
      :src="previewUrl"
      title="CV preview"
      class="w-full h-[70vh] min-h-[600px] rounded bg-white border border-white/10"
      data-testid="cv-preview-frame"
    />
  </div>
</template>
